(function () {
  'use strict';

  function cleanText(value) {
    return String(value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function isHeading(text) {
    var value = cleanText(text);
    if (!value || value.length > 170 || /https?:\/\//i.test(value)) return false;
    if (!/[A-Za-zÀ-ÖØ-öø-ÿ]/.test(value)) return false;
    if (/^SECTION\s+\d+\s*[–-]/i.test(value)) return true;
    return value === value.toLocaleUpperCase();
  }

  function createHeading(documentRef, original, index) {
    var heading = documentRef.createElement('h2');
    heading.id = 'legal-section-' + (index + 1);
    heading.tabIndex = -1;
    heading.textContent = cleanText(original);
    return heading;
  }

  function addSectionChrome(documentRef, section, heading, index, backLabel) {
    var number = documentRef.createElement('span');
    number.className = 'legal-page-redesign__section-number';
    number.setAttribute('aria-hidden', 'true');
    number.textContent = String(index + 1).padStart(2, '0');
    section.insertBefore(number, heading);

    var back = documentRef.createElement('a');
    back.className = 'legal-page-redesign__back-top';
    back.href = '#LegalPageTop';
    back.setAttribute('data-legal-back-top', '');
    back.setAttribute('data-legal-interface', '');

    var icon = documentRef.createElement('img');
    icon.src = window.legalPageArrowAsset || '';
    icon.width = 16;
    icon.height = 16;
    icon.alt = '';
    icon.setAttribute('aria-hidden', 'true');

    var label = documentRef.createElement('span');
    label.textContent = backLabel;
    back.appendChild(icon);
    back.appendChild(label);
    section.appendChild(back);
  }

  function parsePrivacy(source, backLabel) {
    var html = source.innerHTML
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p\s*>/gi, '\n\n')
      .replace(/<p(?:\s[^>]*)?>/gi, '');
    var decoder = document.createElement('div');
    decoder.innerHTML = html;
    var blocks = (decoder.textContent || '')
      .replace(/\r/g, '')
      .split(/\n\s*\n+/)
      .map(function (block) { return block.split('\n').map(cleanText).filter(Boolean); })
      .filter(function (lines) { return lines.length; });

    var fragment = document.createDocumentFragment();
    var preamble = document.createElement('div');
    preamble.className = 'legal-page-redesign__preamble';
    var sections = [];
    var activeSection = null;

    blocks.forEach(function (lines) {
      var first = lines[0];
      if (isHeading(first)) {
        activeSection = document.createElement('section');
        activeSection.className = 'legal-page-redesign__section';
        var heading = createHeading(document, first, sections.length);
        activeSection.appendChild(heading);
        sections.push({ section: activeSection, heading: heading });
        fragment.appendChild(activeSection);
        lines = lines.slice(1);
      }

      if (!lines.length) return;
      var paragraph = document.createElement('p');
      lines.forEach(function (line, lineIndex) {
        if (lineIndex) paragraph.appendChild(document.createElement('br'));
        paragraph.appendChild(document.createTextNode(line));
      });
      (activeSection || preamble).appendChild(paragraph);
    });

    source.innerHTML = '';
    if (preamble.childNodes.length) source.appendChild(preamble);
    source.appendChild(fragment);
    sections.forEach(function (item, index) {
      addSectionChrome(document, item.section, item.heading, index, backLabel);
    });
    return sections;
  }

  function parseTerms(source, backLabel) {
    var container = source.querySelector('.entry-content') || source;
    var nodes = Array.prototype.slice.call(container.children);
    var fragment = document.createDocumentFragment();
    var preamble = document.createElement('div');
    preamble.className = 'legal-page-redesign__preamble';
    var sections = [];
    var activeSection = null;

    nodes.forEach(function (node) {
      var text = cleanText(node.textContent);
      if (node.tagName === 'P' && isHeading(text)) {
        activeSection = document.createElement('section');
        activeSection.className = 'legal-page-redesign__section';
        var heading = createHeading(document, text, sections.length);
        activeSection.appendChild(heading);
        sections.push({ section: activeSection, heading: heading });
        fragment.appendChild(activeSection);
        return;
      }
      (activeSection || preamble).appendChild(node);
    });

    source.innerHTML = '';
    if (preamble.childNodes.length) source.appendChild(preamble);
    source.appendChild(fragment);
    sections.forEach(function (item, index) {
      addSectionChrome(document, item.section, item.heading, index, backLabel);
    });
    return sections;
  }

  function buildContents(root, sections) {
    var list = root.querySelector('[data-legal-contents-list]');
    var toggle = root.querySelector('[data-legal-contents-toggle]');
    if (!list || !toggle) return;
    var items = [];

    sections.forEach(function (item, index) {
      var row = document.createElement('li');
      row.className = 'legal-page-redesign__contents-item';
      var link = document.createElement('a');
      link.className = 'legal-page-redesign__contents-link';
      link.href = '#' + item.heading.id;
      link.setAttribute('data-legal-anchor', '');

      var number = document.createElement('span');
      number.className = 'legal-page-redesign__contents-number';
      number.setAttribute('aria-hidden', 'true');
      number.textContent = String(index + 1).padStart(2, '0');

      var label = document.createElement('span');
      label.textContent = cleanText(item.heading.textContent);

      var icon = document.createElement('img');
      icon.src = window.legalPageChevronAsset || '';
      icon.width = 18;
      icon.height = 18;
      icon.alt = '';
      icon.setAttribute('aria-hidden', 'true');

      link.appendChild(number);
      link.appendChild(label);
      link.appendChild(icon);
      row.appendChild(link);
      list.appendChild(row);
      items.push(row);
    });

    var collapsed = true;
    var labelNode = toggle.querySelector('[data-legal-toggle-label]');
    var toggleNumber = toggle.querySelector('.legal-page-redesign__contents-number');
    var viewAll = root.dataset.viewAllLabel;
    var showFewer = root.dataset.showFewerLabel;

    function render() {
      items.forEach(function (item, index) {
        item.hidden = collapsed && index >= 4;
      });
      toggle.setAttribute('aria-expanded', String(!collapsed));
      labelNode.textContent = collapsed ? viewAll : showFewer;
      toggleNumber.textContent = String(collapsed ? Math.min(5, sections.length + 1) : sections.length + 1).padStart(2, '0');
    }

    if (items.length > 4) {
      toggle.hidden = false;
      render();
      toggle.addEventListener('click', function () {
        collapsed = !collapsed;
        render();
      });
    }
  }

  function bindAnchors(root) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.addEventListener('click', function (event) {
      var anchor = event.target.closest('[data-legal-anchor], [data-legal-back-top]');
      if (!anchor) return;
      var id = anchor.getAttribute('href');
      var target = id && document.querySelector(id);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      if (target.hasAttribute('tabindex')) target.focus({ preventScroll: true });
      if (window.history && window.history.replaceState) window.history.replaceState(null, '', id);
    });
  }

  function initLegalPage(root) {
    if (!root || root.dataset.legalReady === 'true') return;
    root.dataset.legalReady = 'true';
    var source = root.querySelector('[data-legal-source]');
    if (!source) return;
    var backLabel = root.dataset.backTopLabel;
    var sections = root.dataset.legalKind === 'privacy'
      ? parsePrivacy(source, backLabel)
      : parseTerms(source, backLabel);
    buildContents(root, sections);
    bindAnchors(root);
  }

  function boot() {
    window.legalPageArrowAsset = window.legalPageArrowAsset || document.querySelector('[data-legal-contents-toggle] img')?.src || '';
    window.legalPageChevronAsset = window.legalPageChevronAsset || document.querySelector('[data-legal-contents-toggle] img')?.src || '';
    initLegalPage(document.querySelector('[data-legal-page]'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
